{
  "title": "Divine Word",
  "source": "Player's Handbook",
  "levelAndSchool": "7th-level evocation",
  "level": 7,
  "castingTime": "1 bonus action",
  "range": "30 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You utter a divine word, imbued with the power that shaped the world at the dawn of creation. Choose any number of creatures you can see within range. Each creature that can hear you must make a Charisma saving throw. On a failed save, a creature suffers an effect based on its current hit points:",
    "50 hit points or fewer: deafened for 1 minute",
    "40 hit points or fewer: deafened and blinded for 10 minutes",
    "30 hit points or fewer: blinded, deafened, and stunned for 1 hour",
    "20 hit points or fewer: killed instantly",
    "Regardless of its current hit points, a celestial, an elemental, a fey, or a fiend that fails its save is forced back to its plane of origin (if it isn’t there already) and can’t return to your current plane for 24 hours by any means short of a wish spell."
  ],
  "spellLists": ["cleric"]
}
